/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTallymark1 = createReactComponent("outline", "tallymark-1", "IconTallymark1", [["path", { "d": "M12 5l0 14", "key": "svg-0" }]]);

export { IconTallymark1 as default };
//# sourceMappingURL=IconTallymark1.mjs.map
